import Guid from "common/values/guid/guid";
import { Moment } from "moment";


export default class NotificationRecipient {
    private readonly _userId: Guid;
    private readonly _seenAt: Moment | null;

    constructor(userId: Guid, seenAt: Moment | null = null) {
        this._userId = userId;
        this._seenAt = seenAt;
    }

    public get userId(): Guid {
        return this._userId;
    }

    public get seenAt(): Moment | null {
        return this._seenAt;
    }

    public get isSeen(): boolean {
        return this._seenAt !== null;
    }

    public clone(): NotificationRecipient {
        return new NotificationRecipient(this._userId, this._seenAt);
    }

    public isEqualTo(other: NotificationRecipient): boolean {
        return this._userId.isEqualTo(other.userId);
    }
}
